import http from "../http";
const { get } = http;

export default {
  getNewsType(data, config) {
    return get(`/cmoapi/api/get_news_type`, data, config);
  },
  getNewsList(data, config) {
    return get(`/cmoapi/api/get_news_list`, data, config);
  },
  getNews(data, config) {
    return get(`/cmoapi/api/get_news`, data, config);
  },
  getNewsBySearch(data, config) {
    return get(`/cmoapi/api/news_search`, data, config);
  },
  getWinners(data, config) {
    return get(`/cmoapi/api/get_winners`, data, config);
  },
  getWinnersBySearch(data, config) {
    return get(`/cmoapi/api/winners_search`, data, config);
  },
  getDownUrl(data, config) {
    return get(`/cmoapi/api/get_down_url`, data, config);
  },
};
